const ROLES_DE = {
  admin: "Administrator",
  companion: "Begleiter",
  comptable: "Buchhalter",
  gestionnaire: "Verwalter",
  manager: "Manager",
  membre: "Mitglied",
  operative: "Mitarbeiter",
} as const;

export default ROLES_DE;
